import PropTypes from 'prop-types'
import React from 'react'
import { CategoryFilter } from 'Blocks'

const CategoryFilterWrapper = props => {
  const CategoryFilterProps = {
    shouldRender: !!props.products.categories.children,
    className: 'category-filter',
    items: props.products.categories.children,
    gaEventContext:
      props.params.subCategory === 'search' ? 'search' : 'category',
    categoryId: props.params.uuid,
    queryString: props.location.search
  }

  return <CategoryFilter {...CategoryFilterProps} />
}

CategoryFilterWrapper.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.any
  }),
  params: PropTypes.shape({
    subCategory: PropTypes.string,
    uuid: PropTypes.any
  }),
  products: PropTypes.shape({
    categories: PropTypes.shape({
      children: PropTypes.any
    })
  })
}

export default CategoryFilterWrapper
